import styled from "@emotion/styled";
import { fontBarlowSemiCondensed } from "@product/scmp-sdk";

import { ArticleHeaderAdSlot } from "~/components/article/article-header-ad-slot";
import { pageStyle } from "~/components/article/article-render/article-content/standard-styles";
import { StyleArticleAuthorBlock } from "~/components/article/article-render/style-article/style-article-author-block";
import { StyledAdSlot } from "~/components/article/article-render/styles";
import { StyledInlineAdSlot } from "~/components/content/content-schema-render/inline-ad-slot/styles";
import { setFullContentWidthStyles, setFullViewportWidthStyles } from "~/lib/styles";

export const StyleArticleContainer = styled.div`
  display: grid;
  grid:
    "mobile-content-header-ad" min-content
    "section" min-content
    "headline" min-content
    "author" min-content
    "leading" min-content
    "topic-social-container" min-content
    "sub-headline" min-content
    "content" min-content
    "topic" min-content
    "author-detail" min-content
    "more-on-this" min-content
    / 100%;

  inline-size: 100%;

  color: #222222;
  *::selection {
    background: #ffe999;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    grid:
      "header-ad" min-content
      "section" min-content
      "headline" min-content
      "author" min-content
      "leading" min-content
      "topic-social-container" min-content
      "sub-headline" min-content
      "content" min-content
      "topic" min-content
      "author-detail" min-content
      "more-on-this" min-content
      / 100%;
  }

  > *:empty {
    margin: 0;
    padding: 0;
  }
`;

export const DesktopHeaderAdSlot = styled(ArticleHeaderAdSlot)`
  grid-area: header-ad;

  display: none;

  ${props => props.theme.breakpoints.up("desktop")} {
    display: block;
  }

  ${setFullContentWidthStyles()}
`;

const MobileAdSlot = styled.div`
  ${setFullViewportWidthStyles()}

  ${props => props.theme.breakpoints.up("tablet")} {
    display: none;
  }
`;
export const MobileContentHeaderAdSlot = styled(MobileAdSlot)`
  grid-area: mobile-content-header-ad;

  margin-block-start: 20px;
  ${StyledAdSlot} {
    inline-size: fit-content;
    margin: auto;
  }
`;

export const Section = styled.div`
  grid-area: section;

  margin-block-start: 32px;

  a {
    margin-block-end: 16px;

    color: #222222;
    font-weight: 500;
    font-size: 14px;
    font-family: ${fontBarlowSemiCondensed};
    font-style: normal;
    line-height: normal;
    letter-spacing: 1.4px;
    text-transform: uppercase;

    ${props => props.theme.breakpoints.up("tablet")} {
      font-size: 16px;
      letter-spacing: 1.6px;
    }

    ${props => props.theme.breakpoints.up("desktop")} {
      margin-block-end: 24px;

      font-size: 20px;
      letter-spacing: 2px;
    }
  }
`;

export const Headline = styled.div`
  grid-area: headline;

  margin-block-end: 40px;
  margin-inline: auto;
  padding-inline: 20px;

  ${props => props.theme.breakpoints.up("tablet")} {
    max-inline-size: 582px;
    margin-block-end: 48px;
    padding-inline: 0;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    max-inline-size: 824px;
  }

  ${props => props.theme.breakpoints.up("mediumDesktop")} {
    max-inline-size: 972px;
  }

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    max-inline-size: 1092px;
  }
`;

export const Author = styled(StyleArticleAuthorBlock)`
  grid-area: author;
`;

export const Leading = styled.div`
  grid-area: leading;

  ${setFullViewportWidthStyles()}
`;

export const Follow = styled.div`
  margin-block-end: 40px;
  margin-inline: 20px;

  ${props => props.theme.breakpoints.up("tablet")} {
    min-inline-size: 340px;
    margin-inline: 0;
    margin-inline-start: auto;
  }
`;

export const Social = styled.div`
  ${props => props.theme.breakpoints.up("tablet")} {
    inline-size: 100%;
    margin-inline-end: auto;
    padding-inline-start: 6px;
  }
`;

export const TopicSocialContainer = styled.div`
  grid-area: topic-social-container;

  ${props => props.theme.breakpoints.up("tablet")} {
    display: flex;

    inline-size: 582px;
    margin-inline: auto;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    inline-size: 660px;
  }
`;

export const SubHeadline = styled.div`
  grid-area: sub-headline;

  max-inline-size: 582px;
  margin-block-end: 40px;
  margin-inline: auto;
  padding-inline: 20px;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 48px;
    padding-inline: 0;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    max-inline-size: 660px;
  }
`;

export const Content = styled.div`
  grid-area: content;

  ${props => pageStyle(props)}

  ${StyledInlineAdSlot} {
    background-color: #ffffff;
  }
`;

export const Topic = styled.div`
  grid-area: topic;
`;

export const AuthorDetail = styled.div`
  grid-area: author-detail;
`;

export const MoreOnThis = styled.div`
  grid-area: more-on-this;

  margin-block-start: 64px;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-start: 112px;
  }
`;
